// extracted by mini-css-extract-plugin
module.exports = {"extra":"extra--1x9IB","details":"details--24H8j","details__title":"details__title--1KFBH","details__content":"details__content--2aZqs"};